module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc( "UsageCreate", "Create usage" ) ))==null?'':__t)+
'</legend></fieldset><fieldset><div><label for="create-note-input">'+
((__t=( i18n.tc( "UsageCreate", "Note:" ) ))==null?'':__t)+
'</label> <input type="text" id="create-note-input" name="create-note-input" data-input="create-note" required></div><div><label for="create-total-input">'+
((__t=( i18n.tc( "UsageCreate", "Amount:" ) ))==null?'':__t)+
'</label><div class="input input-wrap clearfix"><input type="number" id="create-total-input" name="create-total-input" data-input="create-total"> <input type="number" id="create-cent-input" name="create-cent-input" data-input="create-cent" value="00"></div></div><div><div class="input concession-only"><input type="checkbox" id="usage-create-entire" name="usage-create-entire" data-input="create-entire"> <label class="align-left pt7" for="usage-create-entire">'+
((__t=( i18n.tc("UsageCreate", "Concede entire invoice. (%s remaining)").format(remainingSum) ))==null?'':__t)+
'</label></div></div><div><label for="create-type-input">'+
((__t=( i18n.tc( "UsageCreate", "Type:" ) ))==null?'':__t)+
'</label> <select id="create-type-input" data-input="create-type"><option value="">'+
((__t=( i18n.tc( "UsageCreate", "Select a type" ) ))==null?'':__t)+
'</option> ';
 _.each( usageTypes, function( type ) { 
__p+=' <option value="'+
((__t=( type.value ))==null?'':__t)+
'">'+
((__t=( type.term ))==null?'':__t)+
'</option> ';
 }); 
__p+=' </select> ';
 if ( subscriptions.length > 1 ) { 
__p+=' <label for="select-subscription-input">'+
((__t=( i18n.tc( "UsageCreate", "Subscription:" ) ))==null?'':__t)+
'</label> <select id="select-subscription-input" data-input="select-subscription"><option value="">'+
((__t=( i18n.tc( "UsageCreate", "Select a subscription" ) ))==null?'':__t)+
'</option> ';
 _.each( subscriptions, function( subscription ) { 
__p+=' <option value="'+
((__t=( subscription ))==null?'':__t)+
'">'+
((__t=( subscription ))==null?'':__t)+
'</option> ';
 }); 
__p+=' </select> ';
 } else { 
__p+=' <input type="hidden" id="select-subscription-input" data-input="select-subscription" value="'+
((__t=( subscriptions[0] ))==null?'':__t)+
'"> ';
 } 
__p+=' </div></fieldset><fieldset class="button-wrap"><button data-click="create-cancel">'+
((__t=( i18n.tc( "UsageCreate", "Cancel" ) ))==null?'':__t)+
'</button> <button class="primary" data-click="create-submit" disabled="disabled">'+
((__t=( i18n.tc( "UsageCreate", "Submit" ) ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
